import React, { useState, useEffect } from 'react';

function ProductInfo({ productID }) {
    const [product, setProduct] = useState({});

    useEffect(() => {
        fetch(`https://fakestoreapi.com/products/${productID}`)
            .then(response => response.json())
            .then(data => {
                console.log(data);
                setProduct(data);
            });
    }, [productID]); // Dependency array includes productID to refetch when it changes

    return (
        <div>
            {product ? (
                <div>
                    <h1>{product.title}</h1>
                    <p>Category: {product.category}</p>
                    <p>Description: {product.description}</p>
                    <img src={product.image} alt='Alternative text' className='image'/>
                </div>
            ) : (
                <p>Loading...</p>
            )}
        </div>
    );
}

export default ProductInfo;
